import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=5259ff75&scoped=true"
import script from "./AccordionContent.vue?vue&type=script&lang=js"
export * from "./AccordionContent.vue?vue&type=script&lang=js"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=5259ff75&prod&scoped=true&lang=scss"
import style1 from "./AccordionContent.vue?vue&type=style&index=1&id=5259ff75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5259ff75",
  null
  
)

export default component.exports